import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import {
  ComponentMultiStyleConfig,
  Link,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { hasValue } from "../../../../lib/util/common-util";

export type CMSearchResultCellReactRouterLinkProps = {
  value?: {
    text: string;
    to: string;
  };
} & ComponentStyleProps;

export const CMSearchResultCellReactRouterLink = ({
  value,

  sx,
  ...rest
}: CMSearchResultCellReactRouterLinkProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellReactRouterLinkStyles");

  return (
    <CMSearchResultCellFrame sx={{ ...styles.container, ...sx }} {...rest}>
      {hasValue(value) ? (
        <Link as={RouterLink} to={value.to} sx={styles.content}>
          {value.text}
        </Link>
      ) : null}
    </CMSearchResultCellFrame>
  );
};

export const CMSearchResultCellReactRouterLinkStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "content"],
    baseStyle: {
      container: {},
      content: {
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        color: "blue.600",
      },
    },
  };
